import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import { LogarithmicScale } from "chart.js";
import { useDispatch } from "react-redux";
import { setAvailableLbpBalance, setAvailableUsdBalance } from "../features/accountBalanceSlice";
import { setResponseData } from "../features/transactionDetailsSlice";

const SalesTransactionsAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const [salesTransactions, setSalesTransactions] = useState([]);
    const [totalNbOfPage, SetTotalNbOfPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [salesLoading, setSalesLoading] = useState(false);

    const [availableBalances, setAvailableBalances] = useState([]);
    const [balancesLoading, setBalancesLoading] = useState(false);
    const [exportTSData, setExportTSData] = useState(null);
    const [branchesTillsData, setBranchesTillsData] = useState([]);
    const dispatch = useDispatch();
    

    async function GetSalesTransactions(CurrencyID , pageNb ,dateFrom, dateTo, transactionType,  branchName, tillName, isCustomBranch) {
        setSalesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetSalesTransactions`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType,
                BranchName: branchName || null,  
                TillName: tillName || null,
                IsCustomBranch: isCustomBranch
            }
        ).then((res) => {
            setSalesTransactions(res.data.Payload.SalesTransactions);
            dispatch(setResponseData({field: "transaction", value: res.data.Payload.SalesTransactions}));

            if (res.data.Payload.SalesTransactions?.length===0){
                SetTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                SetTotalNbOfPage(res.data.Payload.SalesTransactions[0].TotalPages);
                setTotalCount(res.data.Payload.SalesTransactions[0].TotalCount);
            }
            setSalesLoading(false);
        }) 
    }

    async function GetAvailableSalesAndBalance() {
        const req = new BaseRequest(sessionStorage.getItem("SessionID"));
        setBalancesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetAvailableSalesAndBalance`,
            req
        ).then((res) => {
            setAvailableBalances(res.data.Payload.AvailableSalesBalances);
            setBalancesLoading(false);

            if(res.data.Payload.AvailableSalesBalances){
                if (res.data.Payload.AvailableSalesBalances[0].AvailableBalance !== null) {

                    sessionStorage.setItem("usdAmount", res.data.Payload.AvailableSalesBalances[0]?.AvailableBalance.toLocaleString('en-US'));
                    dispatch(setAvailableUsdBalance(res.data.Payload.AvailableSalesBalances[0]?.AvailableBalance.toLocaleString('en-US')))
                } else {
                    sessionStorage.setItem("usdAmount", "0")
                }

                if (res.data.Payload.AvailableSalesBalances[1].TotalSales !== null) {

                    sessionStorage.setItem("lbpAmount", res.data.Payload.AvailableSalesBalances[1]?.AvailableBalance.toLocaleString('en-US'));
                    dispatch(setAvailableLbpBalance(res.data.Payload.AvailableSalesBalances[1]?.AvailableBalance.toLocaleString('en-US')))
                } else {
                    sessionStorage.setItem("lbpAmount", "0")
                }
            }
        });
    }

    async function getSTExport(CurrencyID ,dateFrom, dateTo, transactionType) {
        setSalesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetSalesTransactions`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: 1,
                pageSize: 1,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType,
                isExport: true
            }
        ).then((res) => {
            setExportTSData(res.data.Payload.SalesTransactions);
        })
    }

    async function GetBranchesTillsByMerchant() {
        setSalesLoading(true);  
        try {
            const response = await MerchantPortalAxios.post(
                `/v1/Sales/GetBranchesTillsByMerchant`,
                {
                SessionID: sessionStorage.getItem("SessionID")
            }
        );
        setBranchesTillsData(response?.data?.Payload?.BranchesTills);
    } catch (error) {
        setBranchesTillsData([]);
    }
    setSalesLoading(false);  
}
    

    return {
        GetSalesTransactions,
        GetAvailableSalesAndBalance,
        GetBranchesTillsByMerchant,
        salesTransactions,
        totalNbOfPage,
        totalCount,
        salesLoading,
        availableBalances,
        balancesLoading,
        getSTExport,
        exportTSData,
        setExportTSData,
        branchesTillsData,
        setBranchesTillsData,
   
    };
};

export default SalesTransactionsAPI;
